import { useMutation } from 'react-query';
import { RemoteRecruitmentRepo } from '@repository/recruitment/RecruitmentRepo';
import RecruitmentUrlRq from '@domain/rq/recruitment/RecruitmentUrlRq';
import { RecruitmentUrlRs } from '@domain/rs/recruitment/RecruitmentUrlRs';

const repo = new RemoteRecruitmentRepo();

const fetchRecruitmentUrl = async (rq: RecruitmentUrlRq) => {
  const { data } = await repo.fetchRecruitmentUrl(rq);
  return data;
};

export function useRecruitmentUrl(onSuccess?: (data: RecruitmentUrlRs) => void) {
  return useMutation((rq: RecruitmentUrlRq) => fetchRecruitmentUrl(rq), { onSuccess });
}
